<template>
  <v-card
  flat
  bordered>
    <v-toolbar
      flat
      dense
      color="transparent"
    >
    <!-- <v-toolbar-title>Intervention areas</v-toolbar-title> -->
      <v-spacer></v-spacer>
      <v-btn
        v-if="canEdit"
        small
        outlined
        color="primary"
        @click="areasDialog = true"
      >
        Add areas
      </v-btn>
    </v-toolbar>
    <v-list>
      <v-list-item v-for="area in areaList" :key="area.id">
        <v-list-item-content>
          <v-list-item-title v-text="area.name"></v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon v-if="canEdit" @click="disassociateArea(area.id)">
            <v-icon color="grey lighten-1">mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <div v-if="areaList.length === 0" class="text-center">No areas assigned</div>
    </v-list>

    <v-dialog v-model="areasDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>Associate areas</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-form ref="areasAssociation" v-model="areasAssociation.valid">
            <v-checkbox
              v-for="area in availableAreas"
              :key="area.id"
              v-model="areasAssociationRequest"
              :label="area.name"
              :value="area.id"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="secondary darken-1"
            outlined
            @click="areasDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary darken-1"
            @click="
              associateAreas(areasAssociationRequest);
              areasDialog = false;
            "
            >Associate Areas</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import apiService from '@/services'
import { mapState } from 'vuex'

export default {
  props: {
    canEdit: {
      type: Boolean,
      default: false
    },
    entityType: {
      type: String,
      default: '',
      required: true
    },
    entityId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  computed: {
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas']),
    availableAreas () {
      return this.interventionAreas.filter(this.comparer(this.areaList))
    }
  },
  mounted () {
    this.getAreas(this.entityType, this.entityId)
  },
  data () {
    return {
      areaList: [],
      areasDialog: false,
      areasAssociationRequest: [],
      areasAssociation: {
        valid: false
      }
    }
  },
  methods: {
    getAreas (entityType, entityId) {
      apiService
        .getEntityAreas(entityType, entityId)
        .then((data) => {
          this.areaList = data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // Calculate available areas
    comparer (otherArray) {
      return (current) => {
        return (
          otherArray.filter((other) => {
            return other.id === current.id
          }).length === 0
        )
      }
    },

    associateAreas (areas) {
      areas.forEach((area) => {
        apiService
          .associateArea(this.entityType, this.entityId, area)
          .then((response) => {
            this.getAreas(this.entityType, this.entityId)
          })
          .catch((error) => {
            console.log(error)
          })
      })   
    },

    disassociateArea (areaId) {
      apiService
        .disassociateArea(this.entityType, this.entityId, areaId)
        .then((response) => {
          console.log(response)
          this.getAreas(this.entityType, this.entityId)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
